import { render, staticRenderFns } from "./ExamineRecord.vue?vue&type=template&id=2f076383&scoped=true"
import script from "./ExamineRecord.vue?vue&type=script&lang=js"
export * from "./ExamineRecord.vue?vue&type=script&lang=js"
import style0 from "./ExamineRecord.vue?vue&type=style&index=0&id=2f076383&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f076383",
  null
  
)

export default component.exports